export const uk = {
    news: 'Новости'
};
